import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';

const commonColumns = [
    {
        Header: () => 'Solución financiera',
        id: 'id_solution',
        typeId: 'HeaderRequest',
        Cell: ({ row }) => {
            return (
                <RequestIdTableCell
                    row={row}
                    url={`process/${row.original.id}/${row.original.persona.pk}/${row.original.solicitud_id}`}
                    idRoute={row.original.id}
                />
            );
        },
    },
    {
        Header: 'Fecha creación',
        accessor: 'created_at',
    },
    {
        Header: 'Tipo',
        accessor: 'tipo_solucion_financiera.label',
    },
    {
        Header: 'Nro crédito',
        accessor: 'num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: 'Oficina',
        accessor: 'oficina.label',
    },
    {
        Header: 'Ejecutivo',
        accessor: 'ejecutivo.name',
    },
    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const requestsFinancialSolutionsStatus = [
    {
        id: 'bolsa_general',
        label: 'BOLSA GENERAL',
        responsable: false,
        status: '3',
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
        buttonAction: [{ name: 'takeFinancialSolutions' }],
    },
    {
        id: 'en_proceso',
        label: 'EN PROCESO',
        status: '3',
        offices: true,
        responsable: true,
        columns: commonColumns,
        registrationLimit: 5,
        apiSolicitud: false,
    },
    {
        id: 'procesadas',
        label: 'PROCESADAS',
        status: '',
        responsable: false,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(10, 0, {
                Header: 'Gestión Subestado',
                accessor: 'subestado.label',
            });
            return cols;
        })(),
        registrationLimit: 5,
        apiSolicitud: false,
        nameColumnProcessed: [
            {
                name: 'usuario_creacion_gestion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_revision',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
            {
                name: 'usuario_rechazo',
                value: 'user',
                operator: '|',
            },
        ],
    },
];
export default requestsFinancialSolutionsStatus;
